import { render, staticRenderFns } from "./ctyunimage.vue?vue&type=template&id=125b3170&scoped=true"
import script from "./ctyunimage.vue?vue&type=script&lang=js"
export * from "./ctyunimage.vue?vue&type=script&lang=js"
import style0 from "./ctyunimage.vue?vue&type=style&index=0&id=125b3170&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125b3170",
  null
  
)

export default component.exports